import { useCaseGroups } from '@debbie/cortex/dist/case-groups/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Folder } from './Icons/index.js';
import { PALETTE } from './SearchableDropdown.js';
import SearchableSelect from './SearchableSelect.js';
const caseGroupId = (caseGroup) => caseGroup.id;
const caseGroupLabel = (caseGroup) => caseGroup.label;
const FOLDER = { icon: React.createElement(Folder, null), palette: PALETTE.accent };
const folderIcon = () => FOLDER;
const CaseGroupSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseGroups = useCaseGroups();
    return (React.createElement(SearchableSelect, { ...props, placeholder: props.placeholder ?? lang.caseGroups.selectCaseGroup, items: caseGroups, getId: caseGroupId, getLabel: caseGroupLabel, getIcon: folderIcon, labels: {
            search: lang.caseGroups.searchCaseGroups,
            all: lang.caseGroups.caseGroups,
        }, recentsStorageKey: "debbie.caseGroupSelect.recentlyUsed" }));
};
export default CaseGroupSelect;
//# sourceMappingURL=CaseGroupSelect.js.map